import { render } from "./movieVideo.vue?vue&type=template&id=15dcba6a"
import script from "./movieVideo.vue?vue&type=script&lang=js"
export * from "./movieVideo.vue?vue&type=script&lang=js"

import "./movieVideo.vue?vue&type=style&index=0&id=15dcba6a&lang=scss"

import exportComponent from "/home/runner/work/cinema_vue/cinema_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__